export const logout = () => {
  // localStorage.removeItem("USER_DATA");
  localStorage.removeItem("ACTIVE_INSTITUTE");
  localStorage.removeItem("pageState");
};
